import { useAuth } from './AuthProvider.js';
// BOOP system roles
const TierRole = {
    SYSTEM_FURALITY_TEAM: 'rle_7d324e6e-707d-48fa-bcb4-204548b02471',
    SYSTEM_SUPPORTER_TIER_1: 'rle_ca46980f-3ca7-4e59-b8f7-899173a377a3',
    SYSTEM_SUPPORTER_TIER_2: 'rle_a38846f9-92be-4dff-a517-4e2c51c46c03',
    SYSTEM_SUPPORTER_TIER_3: 'rle_6471cc00-fbac-41d0-89f5-8da456700be8',
    SYSTEM_SUPPORTER_BLUE: 'rle_51860e36-ff2c-49f9-86ee-876c96802887',
    SYSTEM_SUPPORTER_GREEN: 'rle_ed1c02d3-7667-42fc-908d-79365a495fbb',
    SYSTEM_SUPPORTER_MAGENTA: 'rle_c3915b7f-446e-44ff-b2e7-4f0ad6788cb4',
    SYSTEM_SUPPORTER_ORANGE: 'rle_13fe2c2d-a1c8-4e91-b13c-acba46acb95a',
    SYSTEM_SUPPORTER_SUPPORTER: 'rle_70f329b8-825a-408e-bc0c-96f4d1e1041f',
};
// all roles
const TierRoles = [
    TierRole.SYSTEM_FURALITY_TEAM,
    TierRole.SYSTEM_SUPPORTER_TIER_1,
    TierRole.SYSTEM_SUPPORTER_TIER_2,
    TierRole.SYSTEM_SUPPORTER_TIER_3,
    TierRole.SYSTEM_FURALITY_TEAM,
    TierRole.SYSTEM_SUPPORTER_BLUE,
    TierRole.SYSTEM_SUPPORTER_GREEN,
    TierRole.SYSTEM_SUPPORTER_MAGENTA,
    TierRole.SYSTEM_SUPPORTER_ORANGE,
    TierRole.SYSTEM_SUPPORTER_SUPPORTER,
];
// all known supporter roles
const Tiers = {
    DiscordTier1: TierRole.SYSTEM_SUPPORTER_TIER_1,
    DiscordTier2: TierRole.SYSTEM_SUPPORTER_TIER_2,
    DiscordTier3: TierRole.SYSTEM_SUPPORTER_TIER_3,
    PatreonSupporter: TierRole.SYSTEM_SUPPORTER_SUPPORTER,
    PatreonBlue: TierRole.SYSTEM_SUPPORTER_BLUE,
    PatreonGreen: TierRole.SYSTEM_SUPPORTER_GREEN,
    PatreonMagenta: TierRole.SYSTEM_SUPPORTER_MAGENTA,
    PatreonOrange: TierRole.SYSTEM_SUPPORTER_ORANGE,
    FuralityTeam: TierRole.SYSTEM_FURALITY_TEAM,
};
// boop role -> our enum
const Mapping = {
    [TierRole.SYSTEM_SUPPORTER_TIER_1]: Tiers.DiscordTier1,
    [TierRole.SYSTEM_SUPPORTER_TIER_2]: Tiers.DiscordTier2,
    [TierRole.SYSTEM_SUPPORTER_TIER_3]: Tiers.DiscordTier3,
    [TierRole.SYSTEM_SUPPORTER_SUPPORTER]: Tiers.PatreonSupporter,
    [TierRole.SYSTEM_SUPPORTER_BLUE]: Tiers.PatreonBlue,
    [TierRole.SYSTEM_SUPPORTER_GREEN]: Tiers.PatreonGreen,
    [TierRole.SYSTEM_SUPPORTER_ORANGE]: Tiers.PatreonOrange,
    [TierRole.SYSTEM_SUPPORTER_MAGENTA]: Tiers.PatreonMagenta,
    [TierRole.SYSTEM_FURALITY_TEAM]: Tiers.FuralityTeam,
};
// who is allowed to join supporter meetups
const SupporterEventAccessRoles = [
    TierRole.SYSTEM_FURALITY_TEAM,
    TierRole.SYSTEM_SUPPORTER_TIER_3,
    TierRole.SYSTEM_SUPPORTER_ORANGE,
];
const NOT_SUPPORTER = {
    supporter: false,
    tier: undefined,
    hasSupporterMeetupAccess: false,
};
export const isSupporter = (auth) => {
    if (auth.state !== 'loggedIn' || auth.user.system_roles == null) {
        return NOT_SUPPORTER;
    }
    const systemRole = auth.user.system_roles.find((role) => TierRoles.includes(role.role_id));
    if (systemRole == null) {
        return NOT_SUPPORTER;
    }
    return {
        supporter: true,
        tier: Mapping[systemRole.role_id],
        hasSupporterMeetupAccess: SupporterEventAccessRoles.some((role) => role === systemRole.role_id),
    };
};
const useIsSupporter = () => isSupporter(useAuth());
export default useIsSupporter;
//# sourceMappingURL=useIsSupporter.js.map